

import React from 'react';
import PropTypes from 'prop-types';

export default function IconDocDefault({ className }) {
  return (
    <svg className={className} fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1V4.5C8 5.32843 8.67157 6 9.5 6H13V13.5C13 14.3284 12.3284 15 11.5 15H4.5C3.67157 15 3 14.3284 3 13.5V2.5C3 1.67157 3.67157 1 4.5 1H8ZM9 1.25V4.5C9 4.77614 9.22386 5 9.5 5H12.75L9 1.25Z" fill="currentColor"/>
    </svg>
  );}

IconDocDefault.propTypes = {
  className: PropTypes.string
};
